import GenericService from './genericService';
import axiosInstance from '../utils/axios';

class PurchaseInvoiceService extends GenericService {
    constructor() {
        super('/purchase_invoices', axiosInstance);
    }

    async pushCloud(purchaseInvoiceId, payload = {}) {
        try {
            const response = await axiosInstance.post(
                `${this.baseUrl}/${this.encodePathSegment(purchaseInvoiceId)}/cloud/push`,
                payload
            );
            return response.data;
        } catch (error) {
            throw this.handleError(error);
        }
    }
}

export default new PurchaseInvoiceService(); 